import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { BiAddToQueue } from 'react-icons/bi';
import cn from 'classnames';

import { Table, Location } from 'services/action';

import { Page, Button } from 'ui/components';
import useTable from 'ui/components/table';
import tableConfig from './component/table.config';
import { SkeletonTable, SkeletonPageFooter } from 'ui/components/skeleton';

import BulkImport from 'ui/screens/authorized/master/location/component/bulk';
import SingleInput from 'ui/screens/authorized/master/location/component/single';
import TableImport from 'ui/screens/authorized/master/location/component/tabel.import';
import { FormBulkUpdate } from 'ui/screens/authorized/master/location/component/form';
import { FormLocations } from 'ui/screens/authorized/_shared/modal/form.location.single';

const initialState = {
  privilege: null,
  showCreate: false,
  datas: [],
  types: null,
  update: null,
  forms: null,
};

const HubScreen = () => {
  const HubTable = useTable('hub', tableConfig);
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );
  const StateTable = useSelector((state) => state?.Table?.data['hub']);
  const StateForm = useSelector((state) => state.Form);

  const [{ showCreate, datas, update, types, forms }, setState] =
    React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      showCreate: false,
      datas: [],
      update: null,
      types: null,
      forms: null,
    }));
  };

  const $handleUpdate = async (d, id) => {
    const u = { id: id, data: datas[id] };
    setState((prevState) => ({
      ...prevState,
      update: u,
    }));
  };

  const $handleDelete = async (id) => {
    let newList = [...datas];
    newList.splice(id, 1);
    setState((prevState) => ({
      ...prevState,
      datas: newList,
      update: null,
    }));
  };

  const $onUpdate = async (d) => {
    let newList = [...datas];
    newList[update?.id] = d;

    setState((prevState) => ({
      ...prevState,
      datas: newList,
      update: null,
    }));
  };

  const $bulkSave = async (c) => {
    const payload = {
      datas: datas,
      type: 'hub',
    };

    const req = await Dispatch(Location.$createBulk(payload));

    if (req?.message === 'success') {
      $resetTable();
      $handleClose();
    }
  };

  const $singleSave = async (c) => {
    const payload = {
      ...forms,
    };

    const req = await Dispatch(Location.$createHub(payload));

    if (req?.message === 'success') {
      $resetTable();
      $handleClose();
    }
  };

  const $handleSubmit = async () => {
    if (types === 'single') {
      $singleSave();
    } else if (types === 'bulk_import') {
      $bulkSave();
    }
  };

  const $resetTable = () => {
    Dispatch(Table.$reload('hub', StateTable));
  };

  return (
    <Page className="col-12 p-md-4 bg-white h-100" isOnboarding>
      <Page.Header
        isOnboarding={
          <div className="py-3 px-0 mt-5 mt-md-0">
            <div
              className="fw-semibold title mb-2 p-0"
              style={{ fontSize: 26 }}
            >
              HUB
            </div>
            <div
              className="page-pretitle fw-normal"
              style={{ textTransform: 'none', fontSize: 12 }}
            >
              Isi HUB untuk menambahkan data lokasi gudang tempat pengiriman dan
              atau penyimpanan Anda.
              <p>Anda harus mendaftarkan HUB untuk melanjutkan</p>
            </div>
          </div>
        }
        className="p-0"
      />
      <Page.Body className="p-md-3 px-3">
        <div className="sub-page-navigation mt-4 mt-md-0">
          <HubTable.Tools>
            <button
              onClick={() =>
                setState((prevState) => ({ ...prevState, showCreate: true }))
              }
              className="btn btn-primary py-1 ms-1"
            >
              <BiAddToQueue color="white" size="14" />
              <span className="d-none d-md-block ms-2">Daftarkan Hub Baru</span>
            </button>
          </HubTable.Tools>
        </div>
        <div className="sub-page-body">
          {StateLoading ? (
            <SkeletonTable headerCount={6} bodyCount={10} />
          ) : (
            <HubTable.Render />
          )}
        </div>

        <div className="sub-page-footer mt-2">
          {StateLoading ? <SkeletonPageFooter /> : <HubTable.Pagination />}
        </div>

        <Modal
          show={showCreate}
          onHide={$handleClose}
          backdrop="static"
          centered
          scrollable
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Buat Lokasi</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {(types === null ||
              (types === 'bulk_import' && datas?.length) === 0) && (
              <div className="row border bg-white m-0">
                <div className="col-md-5 border-bottom-sm d-flex justify-content-center align-items-center">
                  <BulkImport
                    onImported={(e) =>
                      setState((prevState) => ({
                        ...prevState,
                        datas: [...prevState?.datas, e],
                        types: 'bulk_import',
                        update: null,
                      }))
                    }
                  />
                </div>
                <div className="col-md-2 d-flex justify-content-center align-items-center  position-relative">
                  <div
                    className="position-absolute top-50 start-50 translate-middle d-none d-md-flex"
                    style={{
                      height: 150,
                      width: 0.5,
                      backgroundColor: '#848484',
                    }}
                  />
                  <div
                    className="rounded-circle bg-white d-flex justify-content-center align-items-center fs-8 text-uppercase fw-bold text-grey"
                    style={{
                      width: 70,
                      height: 70,
                      zIndex: 9,
                      border: '1px solid #848484',
                    }}
                  >
                    atau
                  </div>
                </div>
                <div className="col-md-5  d-flex justify-content-center align-items-center">
                  <SingleInput
                    onPress={(e) =>
                      setState((prevState) => ({
                        ...prevState,
                        types: 'single',
                        datas: [],
                        update: null,
                      }))
                    }
                  />
                </div>
              </div>
            )}

            {types === 'bulk_import' && datas?.length > 0 && (
              <div>
                {update ? (
                  <FormBulkUpdate
                    data={update?.data}
                    onSubmit={$onUpdate}
                    onClose={() => {
                      setState((prevState) => ({ ...prevState, update: null }));
                    }}
                  />
                ) : null}

                <div className="mt-3">
                  <TableImport
                    data={datas}
                    onDelete={$handleDelete}
                    onUpdate={$handleUpdate}
                  />
                </div>
              </div>
            )}

            {types === 'single' && (
              <FormLocations
                onFormChange={(e) =>
                  setState((prevState) => ({ ...prevState, forms: e }))
                }
                type="hub"
              />
            )}
          </Modal.Body>

          {types === 'single' ||
          (types === 'bulk_import' && datas?.length > 0) ? (
            <Modal.Footer>
              <div className="row w-100">
                <div className="col">
                  <Button
                    type="button"
                    className="btn btn-light w-100"
                    onClick={$handleClose}
                  >
                    Batal
                  </Button>
                </div>
                <div className="col">
                  <Button
                    type="button"
                    className={cn(
                      StateForm?.loading ? 'btn-loading' : '',
                      'btn btn-primary w-100'
                    )}
                    disabled={StateForm?.loading}
                    onClick={$handleSubmit}
                  >
                    Simpan
                  </Button>
                </div>
              </div>
            </Modal.Footer>
          ) : null}
        </Modal>
      </Page.Body>

      <Page.Footer className="justify-content-center gap-2 pt-3 border-top d-md-flex d-block mb-3 flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-3"
          onClick={() => History.push('/onboarding-client')}
        >
          Sebelumnya
        </Button>
        <Button
          type="button"
          className="btn-primary py-3"
          onClick={() => History.push('/onboarding-services')}
          disabled={StateTable?.data?.length === 0}
        >
          Selanjutnya
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default HubScreen;
